import { ReactNode } from 'react';

type AutoHideOnProps = {
    hideOn: Date;
    children: ReactNode | ReactNode[];
};

/**
 * Auto hides a component at a certain date.
 * Accepts the following props:
 * - hideOn {Date} the date at which to hide this component (will automatically be compared to the current date)
 * - children: Component to show or hide
 * @returns child component if in date, else null
 */
function AutoHideOn({ hideOn, children }: AutoHideOnProps): JSX.Element | null {
    if (new Date().getTime() > hideOn.getTime()) {
        return null;
    }
    return <>{children}</>;
}

export default AutoHideOn;
